import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React from 'react';

import { DispatchDetail, Shipment } from '../../../../../@types/shipment.type';
import { useUpdateShipment } from '../../../../../queries/shipment-query';
import { toast } from '../../../../../utils/toast';
import { ShippingMethodFragment } from '../../../../Shipments/Dispatch/ShippingMethodFragment';

export interface PostCreateShippingMethodProps {
  shipment: Shipment;
  onClose: () => void;
}

const shipmentToDispatchDetail = (shipment: Shipment): DispatchDetail => ({
  id: shipment.id,
  source: shipment.source,
  sourceNodeId: shipment.sourceNodeId,
  destination: shipment.destination,
  destinationNodeId: shipment.destinationNodeId,
  shipmentStatusCode: shipment.shipmentStatusCode,
  clientHierarchy: shipment.clientHierarchy,
  clientHierarchySearch: shipment.clientHierarchySearch,
  clientHierarchyName: shipment.clientHierarchyName,
  client: shipment.client,
  contract: shipment.contract,
  serviceId: shipment.serviceId,
  bypassReceipt: shipment.bypassReceipt,
  overrideConsumption: shipment.overrideConsumption,
  connoteNo: shipment.connoteNo,
  note: shipment.note,
  shipmentTypeCode: shipment.shipmentTypeCode,
  shippingCost: shipment.shippingCost,
  referenceNumber1: shipment.referenceNumber1,
  referenceNumber2: shipment.referenceNumber2,
  referenceNumber3: shipment.referenceNumber3,
  createdAt: shipment.createdAt,
  createdBy: shipment.createdBy,
  updatedAt: shipment.updatedAt,
  updatedBy: shipment.updatedBy,
});

export const PostCreateShippingMethod: React.FC<PostCreateShippingMethodProps> = ({
  shipment,
  onClose,
}) => {
  const dispatchDetail = shipmentToDispatchDetail(shipment);
  const updateShipment = useUpdateShipment();

  const handleSaveManual = async (data: { shippingProviderId: number; connoteNo: string }) => {
    try {
      await updateShipment.mutateAsync({ ...dispatchDetail, ...data });
      onClose();
    } catch {
      toast.error('Failed to save shipping method. Please try again.');
    }
  };

  return (
    <Box sx={{ mt: 1 }}>
      <ShippingMethodFragment shipment={dispatchDetail} onSaveManual={handleSaveManual} />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
        <Button
          size="small"
          variant="text"
          onClick={onClose}
          sx={{ fontSize: '11px', textTransform: 'none', color: 'text.secondary' }}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
};
